import { FC, useMemo } from 'react'
import styles from 'components/features/socialFeed/SocialInsightReviewList/SocialInsightReviewList.styl'
import { createFeedAllCommentUidsByPostUidSelector, feedPostSelector } from 'selectors/feedSelectors'
import { useStoreSelector, useShallowSelector } from 'helpers/reactReduxHelpers'
import { WithPostUid } from 'interfaces/feed'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import { CommentListLoadingHandler } from 'components/features/socialFeed/CommentListLoadingHandler/CommentListLoadingHandler'
import Deferred from 'components/utils/Deferred'
import FeedPostCommentsOrdering from 'components/features/socialFeed/FeedPostCommentsOrdering/FeedPostCommentsOrdering'
import { SocialInsightReview } from 'components/features/socialFeed/SocialInsightReview/SocialInsightReview'

const DeferredSpinner = Deferred(Spinner, 300)

type SocialInsightReviewListProps =
  & WithPostUid
  & {
  }

export const SocialInsightReviewList: FC<SocialInsightReviewListProps> = (props) => {
  const { postUid } = props

  const commentsSelector = useMemo(createFeedAllCommentUidsByPostUidSelector, [])
  const comments = useStoreSelector((state) => commentsSelector(state, props))
  const { comments_count } = useShallowSelector((state) => ({
    comments_count: 0,
    ...feedPostSelector(state, props),
  }))

  const { hasItems, hasMore } = useMemo(() => ({
    hasItems: Boolean(comments && comments.results.length),
    hasMore: Boolean(comments && comments.results.length < comments_count && comments.pagination && comments.pagination.next),
  }), [comments, comments_count])

  const isLoading = useStoreSelector((state) => {
    return !!state.app.feed.postCommentsLoadingIds[postUid]
  })

  const sortChild = useMemo(() => {
    if (comments_count < 3) {
      return null
    }
    return (
      <div>
        <FeedPostCommentsOrdering postUid={ postUid } />
      </div>
    )
  }, [comments_count, postUid])

  const commentsChild = useMemo(() => {
    if (!comments || !hasItems) {
      return null
    }
    return (
      <div className={ styles.commentsWrapper }>
        { comments.results.map((uid) => {
          return ((
            <div key={ uid }>
              <SocialInsightReview commentUid={ uid } />
            </div>
          ))
        })}
      </div>
    )
  }, [comments, hasItems])

  return (
    <>
      <CommentListLoadingHandler postUid={ postUid } />
      { !hasItems && isLoading && (
        <div className={ styles.loadSpinnerWrapper }>
          <Spinner />
        </div>
      )}
      { hasItems && (
        <div className={ styles.socialInsightReviewList }>
          { sortChild }

          { commentsChild }

          { hasMore &&
            <div
              className={ styles.hasMore }
              onClick={ undefined }
            >
              <span className={ styles.hasMoreCopyWrapper }>
                View more comments
                { isLoading && (
                  <div className={ styles.spinnerWrapper }>
                    <DeferredSpinner />
                  </div>
                )}
              </span>
            </div>}
        </div>
      )}
    </>
  )
}
